export default [
  {
    name: `video_intro`,
    exitButton: `跳过视频`,
  },
];
